import { z } from 'zod';

const formatSchema = z.union([
  z.literal('auto'),
  z.literal('jpg'),
  z.literal('png'),
  z.literal('ktx-basis-uastc'),
  z.literal('ktx-basis-etcs1'),
  z.literal('webp'),
]);

export const CompressionAndExportSchema = z.object({
  fileExports: z.array(
    z.object({
      fileType: z.union([
        z.literal('glb'),
        z.literal('gltf'),
        z.literal('usd'),
        z.literal('usdz'),
        z.literal('obj'),
        z.literal('stl'),
        z.literal('ply'),
        z.literal('ctm'),
        z.literal('fbx'),
        z.literal('vrm'),
      ]),
      meshCompressionMethod: z.union([z.literal('none'), z.literal('draco'), z.literal('dracoLossy')]).optional(),
      customScaling: z.number().gte(0).optional(),
      textureFormat: z
        .object({
          baseColor: formatSchema,
          emissive: formatSchema,
          normal: formatSchema,
          orm: formatSchema,
        })
        .optional(),
      scaleFactor: z.number().gte(0).default(1).optional(),
      ktxSettings: z
        .object({
          compressionSpeed: z.number().gte(0).lte(5).optional(),
          quality: z.number().gte(0).lte(255).optional(),
        })
        .optional(),
    })
  ),
  filename: z
    .object({
      useId: z.boolean(),
      usePresetName: z.boolean(),
      useSuffix: z.string(),
    })
    .optional(),
});
